export default "__VITE_ASSET__zn92emX___"